var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { StarIcon } from '@heroicons/react/20/solid';
import { Translate } from "../../../../../I18N";
import { Button } from "../../../../Components/UI/Button";



const DefaultButton = ({ cell, column }) => /*#__PURE__*/
_jsx(Button, {
  styling: cell.row.original.default ? 'solid' : 'light',
  onClick: async () => {var _column$columnDef$met, _column$columnDef$met2;return (_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : (_column$columnDef$met2 = _column$columnDef$met.action) === null || _column$columnDef$met2 === void 0 ? void 0 : _column$columnDef$met2.call(_column$columnDef$met, cell.row);},
  className: "leading-4" }, void 0, /*#__PURE__*/

_jsx(Translate, { className: "sr-only" }, void 0, "Default"), /*#__PURE__*/
_jsx(StarIcon, {
  className: `${
  !cell.row.original.default ?
  ' w-4 text-white stroke-current stroke-gray-300 stroke-2' :
  'w-4'
  }` }
)
);


const UninstallButton = ({ cell, column }) =>
!cell.row.original.default ? /*#__PURE__*/
_jsx(Button, {
  styling: "outline",
  onClick: () => {var _column$columnDef$met3, _column$columnDef$met4;return (_column$columnDef$met3 = column.columnDef.meta) === null || _column$columnDef$met3 === void 0 ? void 0 : (_column$columnDef$met4 = _column$columnDef$met3.action) === null || _column$columnDef$met4 === void 0 ? void 0 : _column$columnDef$met4.call(_column$columnDef$met3, cell.row);},
  className: "leading-4" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Uninstall")
) : /*#__PURE__*/

React.createElement(React.Fragment, null, " ");


const ResetButton = ({ cell, column }) =>
cell.row.original.translationAvailable ? /*#__PURE__*/
_jsx(Button, {
  styling: "outline",
  onClick: () => {var _column$columnDef$met5, _column$columnDef$met6;return (_column$columnDef$met5 = column.columnDef.meta) === null || _column$columnDef$met5 === void 0 ? void 0 : (_column$columnDef$met6 = _column$columnDef$met5.action) === null || _column$columnDef$met6 === void 0 ? void 0 : _column$columnDef$met6.call(_column$columnDef$met5, cell.row);},
  className: "leading-4" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Reset")
) : /*#__PURE__*/

React.createElement(React.Fragment, null, " ");


const LanguageLabel = ({ cell }) => /*#__PURE__*/
_jsx(Translate, {}, void 0, `${cell.row.original.label} (${cell.row.original.key})`);


const LabelHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Language");

const DefaultHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Default language");

const ResetHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Reset language");

const UninstallHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Uninstall language");

export {
  LanguageLabel,
  LabelHeader,
  DefaultHeader,
  UninstallHeader,
  DefaultButton,
  UninstallButton,
  ResetButton,
  ResetHeader };